/*
 * ************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *   Copyright 2021 Adobe Systems Incorporated
 *   All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 * ************************************************************************
 */

import { connect } from '@airglow/store-redux';
import { updateSettingsValidation } from '../actions';
import { selectValidationPluginsGrouped, selectUpdatedSettingsValidation } from '../selectors';
import SettingsValidation from '../../ui/workspaces/settings.validation';

const mapState = state => ({
  plugins: selectValidationPluginsGrouped(state),
  settings: selectUpdatedSettingsValidation(state)
});

const mapHandlers = dispatch => ({
  onChangeArguments: (namespace, value) => dispatch(updateSettingsValidation({
    namespace,
    setting: 'arguments',
    value
  })),
  onSelectLevel: (namespace, value) => dispatch(updateSettingsValidation({
    namespace,
    setting: 'level',
    value
  }))
});

export default connect(mapState, mapHandlers)(SettingsValidation);
